import { render } from "./PcPageMain.vue?vue&type=template&id=c23c5a62&ts=true"
import script from "./PcPageMain.vue?vue&type=script&lang=ts"
export * from "./PcPageMain.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__